import React, { Fragment } from 'react';
import Card from './Card';
import Header from './Header';

const NewEstablishment = (props) => (
    <Fragment>
        <Header headerName={props.headerName} />
        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <Card {...props} />
                </div>
            </div>
        </div>
    </Fragment>
);

export default NewEstablishment;


// WEBPACK FOOTER //
// ./src/components/Pages/Terminals/Management/index.js